// extracted by mini-css-extract-plugin
module.exports = {"tooltipTitle":"styles_tooltipTitle__kS1QZ","KeywordStyle":"styles_KeywordStyle__3z7cw","descStyle":"styles_descStyle__3YRmW","boldStyles":"styles_boldStyles__1HVca"};